import { Injectable, RendererFactory2, Renderer2 } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type AppLayout = 'sidebar' | 'top';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  private renderer: Renderer2;
  private readonly KEY = 'dhs-layout';
  private readonly TOP_CLASS = 'layout-topnav';

  private _layout$ = new BehaviorSubject<AppLayout>('sidebar');
  layout$ = this._layout$.asObservable();

  get layout(): AppLayout {
    return this._layout$.value;
  }

  get isTop(): boolean {
    return this._layout$.value === 'top';
  }

  constructor(factory: RendererFactory2) {
    this.renderer = factory.createRenderer(null, null);
    this.apply(localStorage.getItem(this.KEY) === 'top' ? 'top' : 'sidebar');
  }

  set(layout: AppLayout): void {
    this.apply(layout);
  }

  private apply(layout: AppLayout): void {
    this._layout$.next(layout);
    localStorage.setItem(this.KEY, layout);
    if (layout === 'top') {
      this.renderer.addClass(document.body, this.TOP_CLASS);
    } else {
      this.renderer.removeClass(document.body, this.TOP_CLASS);
    }
  }
}
